export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    showMoreButton: {
        width: 145,
        height: 30,
        marginTop: 8,
        marginBottom: 37,
        alignSelf: 'center',
        fontSize: '14px',
        color: 'white',
        background: '#3D95FB',
        border: 'none',
        borderRadius: 4,
        cursor: 'pointer',

        svg: {
            marginLeft: 5,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
